import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgDownward({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.02 22h-.039a.987.987 0 01-.13-.01l-.052-.01a.994.994 0 01-.394-.176l-.013-.01a1.022 1.022 0 01-.099-.087l.09.08-.035-.029.035.03a1.01 1.01 0 01-.09-.08l-9-9.001a1 1 0 011.32-1.498l.094.084L11 18.587V3a1 1 0 01.884-.993L12 2a1 1 0 01.993.884L13 3v15.586l7.293-7.293a1 1 0 011.32-.084l.094.084a1 1 0 010 1.414l-9 9a1.035 1.035 0 01-.335.222.968.968 0 01-.223.06l-.067.008a.995.995 0 01-.023.001l-.005.001-.034.001zm-.727-.293a.995.995 0 00.112.097l-.035-.028-.077-.069z"
        fill={color}
      />
    </svg>
  )
}

export default SvgDownward
